import { render, staticRenderFns } from "./PredelavaUkazi.vue?vue&type=template&id=569c48c4&"
import script from "./PredelavaUkazi.vue?vue&type=script&lang=js&"
export * from "./PredelavaUkazi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports